<script setup lang="ts">
import {
  ItinerarySegmentPlaceholderType,
  ItinerarySegmentPlaceholder,
} from '@apps/main/new-desktop/modules/itineraryButton';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppSingleSelect } from '@libs/ui';

import type { AvailableItineraryActivitySegment } from '../../../models';
import ItineraryTimeline from '../ItineraryTimeline.vue';

import ActivityProductCard from './ActivityProductCard.vue';
import ActivityCardHeader from './ActivityCardHeader.vue';

const { t } = i18n.global;

interface AvailableActivitySegmentProps {
  segment: AvailableItineraryActivitySegment;
  printMode: boolean;
  shouldHideProductLink: boolean;
}

const props = defineProps<AvailableActivitySegmentProps>();

interface AvailableActivitySegmentEmits {
  (eventName: 'change-product'): void;
  (eventName: 'remove-activity'): void;
  (eventName: 'show-details'): void;
  (eventName: 'show-details-tickets'): void;
}

const emit = defineEmits<AvailableActivitySegmentEmits>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="available-activity-segment"
  >
    <template #dropdown>
      <AppSingleSelect
        v-if="!props.shouldHideProductLink"
        type="primary"
        :selected="{
          id: 1,
          label: t('planner.activity'),
          icon: 'activity',
        }"
        left-side-icon="activity"
        :options="[]"
        disabled
      />
      <ItinerarySegmentPlaceholder
        v-else
        :transport-type="ItinerarySegmentPlaceholderType.Activity"
      />
    </template>
    <template #header>
      <ActivityCardHeader
        v-if="!props.shouldHideProductLink"
        :print-mode="props.printMode"
        @remove="emit('remove-activity')"
      />
    </template>

    <template #content>
      <ActivityProductCard
        :product-card-data="props.segment.productCardData"
        :product-card-context="props.segment.context"
        :date="props.segment.date"
        :print-mode="props.printMode"
        :should-hide-product-link="props.shouldHideProductLink"
        @show-details="emit('show-details')"
        @show-details-tickets="emit('show-details-tickets')"
        @change-product="emit('change-product')"
        @remove="emit('remove-activity')"
      />
    </template>
  </ItineraryTimeline>
</template>
